'use client'

import moment from 'moment';
import LoginForm from '../ui/login-form';
import { Suspense } from 'react';

export const dynamic = 'force-dynamic';

export default function Page() {

  return (
    <main className="min-h-screen">

      {moment().month() === 11 ? <div className="snowflakes" aria-hidden="true">
        <div className="snowflake">❅</div>
        <div className="snowflake">❆</div>
        <div className="snowflake">❅</div>
        <div className="snowflake">❆</div>
        <div className="snowflake">❅</div>
        <div className="snowflake">❆</div>
        <div className="snowflake">❅</div>
        <div className="snowflake">❆</div>
        <div className="snowflake">❅</div>
        <div className="snowflake">❆</div>
        <div className="snowflake">❅</div>
        <div className="snowflake">❆</div>
      </div> : ""}

      {moment().month() === 3 ? <div className="snowflakes" aria-hidden="true">
        <div className="snowflake">🐰</div>
        <div className="snowflake">🐰</div>
        <div className="snowflake">🐰</div>
        <div className="snowflake">🐰</div>
        <div className="snowflake">🐰</div>
        <div className="snowflake">🐰</div>
        <div className="snowflake">🐰</div>
        <div className="snowflake">🐰</div>
        <div className="snowflake">🐰</div>
        <div className="snowflake">🐰</div>
        <div className="snowflake">🐰</div>
        <div className="snowflake">🐰</div>
      </div> : ""}

      <div className="md:min-h-screen md:w-full bg-gray-700 hidden md:block">
        <img src='/loginbg.png' className='min-h-screen w-full opacity-40' />
      </div>
      <div className="min-h-screen w-full block md:hidden">
        <img src='/loginbg.png' className='min-h-screen w-full opacity-30' />
      </div>

      <div className='md:fixed md:top-1/2 md:left-1/2 md:-translate-x-1/2 md:-translate-y-1/2  md:w-1/3 md:p-6 md:block hidden '>
        <Suspense fallback={<div>Carregando...</div>}>
          <LoginForm />
        </Suspense>
      </div>

      <div className='md:hidden fixed inset-y-3 flex justify-center items-center h-screen w-full'>
        <Suspense fallback={<div>Carregando...</div>}>
          <LoginForm />
        </Suspense>
      </div>

    </main>
  );
}